import React from "react";
// import Modal from "react-bootstrap/Modal";
// import Joi from "joi-browser";
// import { toast } from "react-toastify";
// import Input from "../common/Input";
// import Select from "../common/Select";

function AddApplication({ state }) {
  // const [isOpen, setIsOpen] = useState(false);
  // const [errors, setErrors] = useState({});
  // const [data, setData] = useState({});

  // const joiSchema = {
  //   division: Joi.string().required().label("Division"),
  //   inquiryDate: Joi.string().required().label("Date of Inquiry"),
  //   primaryFirstName: Joi.string()
  //     .required()
  //     .label("Primary Applicant First Name"),
  //   primaryFirstName: Joi.string().allow(["", null]),
  //   primaryLastName: Joi.string()
  //     .required()
  //     .label("Primary Applicant Last Name"),
  //   primarySuffix: Joi.string().allow(["", null]),
  //   primaryEmail: Joi.string().allow(["", null]),
  //   primaryPhone: Joi.string().allow(["", null]),
  //   secondaryFirstName: Joi.string().allow(["", null]),
  //   secondaryFirstName: Joi.string().allow(["", null]),
  //   secondaryLastName: Joi.string().allow(["", null]),
  //   secondarySuffix: Joi.string().allow(["", null]),
  //   secondaryEmail: Joi.string().allow(["", null]),
  //   secondaryPhone: Joi.string().allow(["", null]),
  // };

  // const divisionOptions = {
  //   alabama: [
  //     { _id: "Birmingham", name: "Birmingham" },
  //     { _id: "Huntsville", name: "Huntsville" },
  //     { _id: "Mobile", name: "Mobile" },
  //     { _id: "Montgomery", name: "Montgomery" },
  //   ],
  //   colorado: [{ _id: "Northern Colorado", name: "Northern Colorado" }],
  //   indiana: [
  //     { _id: "Fort Wayne", name: "Fort Wayne" },
  //     { _id: "Indianapolis", name: "Indianapolis" },
  //     { _id: "Merrillville", name: "Merrillville" },
  //     { _id: "Mishawaka", name: "Mishawaka" },
  //     { _id: "Southern Indiana", name: "Southern Indiana" },
  //   ],
  //   kentucky: [
  //     { _id: "Bowling Green", name: "Bowling Green" },
  //     { _id: "Lexington", name: "Lexington" },
  //     { _id: "Louisville", name: "Louisville" },
  //     { _id: "Northern Kentucky", name: "Northern Kentucky" },
  //     { _id: "Somerset", name: "Somerset" },
  //   ],
  //   nevada: [{ _id: "Las Vegas", name: "Las Vegas" }],
  //   ohio: [
  //     { _id: "Canton", name: "Canton/Akron" },
  //     { _id: "Cincinnati", name: "Cincinnati" },
  //     { _id: "Cleveland", name: "Cleveland" },
  //     { _id: "Columbus", name: "Columbus" },
  //     { _id: "Dayton", name: "Dayton" },
  //     { _id: "Findlay", name: "Findlay" },
  //     { _id: "Sidney", name: "Sidney" },
  //   ],
  //   southcarolina: [
  //     { _id: "Charleston", name: "Charleston" },
  //     { _id: "Columbia", name: "Columbia" },
  //     { _id: "Greenville", name: "Greenville" },
  //   ],
  // };

  // const handleChange = ({ currentTarget: input }) => {
  //   const errs = { ...errors };
  //   const errorMessage = validateProperty(input);
  //   if (errorMessage) {
  //     errs[input.name] = errorMessage;
  //     console.log("Errors:", JSON.stringify(errs));
  //   } else {
  //     delete errs[input.name];
  //   }

  //   const obj = { ...data };
  //   obj[input.name] = input.value;
  //   setData(obj);
  //   setErrors(errs);
  // };

  // const validateProperty = ({ name, value }) => {
  //   const obj = { [name]: value };
  //   const schema = { [name]: joiSchema[name] };
  //   const { error } = Joi.validate(obj, schema);
  //   return error ? error.details[0].message : null;
  // };

  // const validate = () => {
  //   const options = { abortEarly: false };
  //   const { error } = Joi.validate(data, joiSchema, options);
  //   if (!error) return null;

  //   let validationErrors = {};
  //   for (let item of error.details)
  //     validationErrors[item.path[0]] = item.message;
  //   setErrors(validationErrors);
  //   return validationErrors;
  // };

  // const clearData = () => {
  //   const obj = {
  //     division: null,
  //     inquiryDate: null,
  //     primaryFirstName: null,
  //     primaryFirstName: null,
  //     primaryLastName: null,
  //     primarySuffix: null,
  //     primaryEmail: null,
  //     primaryPhone: null,
  //     secondaryFirstName: null,
  //     secondaryFirstName: null,
  //     secondaryLastName: null,
  //     secondarySuffix: null,
  //     secondaryEmail: null,
  //     secondaryPhone: null,
  //   };
  //   setData(obj);
  //   setErrors([]);
  // };

  return (
    <>
      {/* <Modal
        size="xl"
        show={isOpen}
        animation={false}
        onHide={() => {
          setIsOpen(false);
          clearData();
        }}
      >
        <Modal.Header closeButton className="bg-safy-info text-white">
          <Modal.Title>{`Create Application in Binti`}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-6 text-danger fw-bold">
              <Select
                name="division"
                label="Division"
                options={
                  divisionOptions[state.toLowerCase().replaceAll(" ", "")]
                }
                value={data.division}
                error={errors.division}
                onChange={handleChange}
              ></Select>
            </div>
            <div className="col-3"></div>
            <div className="col-3 text-danger fw-bold">
              <Input
                name="inquiryDate"
                label="Date of Inquiry"
                type="date"
                error={errors.inquiryDate}
                value={data.inquiryDate}
                onChange={handleChange}
              ></Input>
            </div>
          </div>
          <div className="border rounded p-2 mb-4 card-safy bg-light">
            <div className="h4">Primary Applicant Info</div>
            <div className="row">
              <div className="col-4 ">
                <div className="text-danger fw-bold">
                  <Input
                    name="primaryFirstName"
                    label="First Name"
                    error={errors.primaryFirstName}
                    value={data.primaryFirstName}
                    onChange={handleChange}
                  ></Input>
                </div>
              </div>
              <div className="col-2">
                <Input
                  name="primaryMiddleName"
                  label="Middle Name"
                  error={errors.primaryMiddleName}
                  value={data.primaryMiddleName}
                  onChange={handleChange}
                ></Input>
              </div>
              <div className="col-4">
                <div className="text-danger fw-bold">
                  <Input
                    name="primaryLastName"
                    label="Last Name"
                    error={errors.primaryLastName}
                    value={data.primaryLastName}
                    onChange={handleChange}
                  ></Input>
                </div>
              </div>
              <div className="col-2">
                <Input
                  name="primarySuffix"
                  label="Suffix"
                  error={errors.primarySuffix}
                  value={data.primarySuffix}
                  onChange={handleChange}
                ></Input>
              </div>
            </div>
            <div className="row">
              <div className="col-6">
                <Input
                  name="primaryEmail"
                  label="Email"
                  error={errors.primaryEmail}
                  value={data.primaryEmail}
                  onChange={handleChange}
                ></Input>
              </div>
              <div className="col-6">
                <Input
                  name="primaryPhone"
                  label="Primary Phone"
                  error={errors.primaryPhone}
                  value={data.primaryPhone}
                  onChange={handleChange}
                ></Input>
              </div>
            </div>
          </div>
          <div className="border rounded p-2 mb-4 card-safy bg-light">
            <div className="h4">Secondary Applicant Info</div>
            <div className="row">
              <div className="col-4">
                <Input
                  name="secondaryFirstName"
                  label="First Name"
                  error={errors.secondaryFirstName}
                  value={data.secondaryFirstName}
                  onChange={handleChange}
                ></Input>
              </div>
              <div className="col-2">
                <Input
                  name="secondaryMiddleName"
                  label="Middle Name"
                  error={errors.secondaryMiddleName}
                  value={data.secondaryMiddleName}
                  onChange={handleChange}
                ></Input>
              </div>
              <div className="col-4">
                <Input
                  name="secondaryLastName"
                  label="Last Name"
                  error={errors.secondaryLastName}
                  value={data.secondaryLastName}
                  onChange={handleChange}
                ></Input>
              </div>
              <div className="col-2">
                <Input
                  name="secondarySuffix"
                  label="Suffix"
                  error={errors.secondarySuffix}
                  value={data.secondarySuffix}
                  onChange={handleChange}
                ></Input>
              </div>
            </div>
            <div className="row">
              <div className="col-6">
                <Input
                  name="secondaryEmail"
                  label="Email"
                  error={errors.secondaryEmail}
                  value={data.secondaryEmail}
                  onChange={handleChange}
                ></Input>
              </div>
              <div className="col-6">
                <Input
                  name="secondaryPhone"
                  label="Primary Phone"
                  error={errors.secondaryPhone}
                  value={data.secondaryPhone}
                  onChange={handleChange}
                ></Input>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-danger"
            onClick={() => {
              setIsOpen(false);
            }}
          >
            Cancel
          </button>
          <button
            className={
              Object.keys(errors).length === 0
                ? "btn btn-primary"
                : "btn btn-secondary"
            }
            disabled={Object.keys(errors).length !== 0}
            onClick={() => {
              if (!validate()) {
                toast.success(
                  "This would have created an application in Binti"
                );
                clearData();
                setIsOpen(false);
              }
            }}
          >
            Submit
          </button>
        </Modal.Footer>
      </Modal> */}
      <div
        className="btn btn-primary"
        role="button"
        onClick={() => {
          // clearData();
          // setIsOpen(true);
          window.open("https://family.binti.com/admin/intake_forms/new");
        }}
      >
        Add Application in Binti
      </div>
    </>
  );
}

export default AddApplication;
